export function roundToDecimal (number: number, decimal: number = 1): number {
  return +parseFloat(number.toString()).toFixed(decimal);
}

export function toRadians (degrees: number): number {
  return (degrees * Math.PI) / 180;
}
